"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[190],{

/***/ 87190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zx": function() { return /* reexport */ Button; }
});

// UNUSED EXPORTS: A, AnchorButton, ClearActionButton, DateField, DollarField, ErrorText, FieldLabel, Grid, GridItem, HelpText, InputBaseComponent, LUIProvider, NumericField, P, PhoneField, RichText, Section, SelectField, Spacer, StyledSection, Text, TextField, Theme, UnitField, VerticalRhythm, Wrapper, aussieTheme, cleanNumericValue, dollarToNumber, domainTheme, lendiNextTheme, renderWithTheme, select, theme, useClearAction, useFlexGap, useFlexGapPolyfill, useTheme

// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/styled-components/dist/styled-components.browser.esm.js + 6 modules
var styled_components_browser_esm = __webpack_require__(90471);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/commons/utils/dist/commons.esm.js
var commons_esm = __webpack_require__(7401);
// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../node_modules/@lendi/ui/dist/index-03130070.esm.js
var index_03130070_esm = __webpack_require__(66299);
;// CONCATENATED MODULE: ../node_modules/@lendi/ui/dist/objectWithoutProperties-7e1dfdab.esm.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function objectWithoutProperties_7e1dfdab_esm_objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}



;// CONCATENATED MODULE: ../node_modules/@lendi/ui/dist/index-9102c435.esm.js







// remove this once safari support ships
function checkFlexGap() {
  var _flex$parentNode;
  // create flex container with row-gap set
  var flex = document.createElement('div');
  flex.style.display = 'flex';
  flex.style.flexDirection = 'column';
  flex.style.rowGap = '1px';

  // create two, elements inside it
  flex.appendChild(document.createElement('div'));
  flex.appendChild(document.createElement('div'));

  // append to the DOM (needed to obtain scrollHeight)
  document.body.appendChild(flex);
  var isSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap
  flex === null || flex === void 0 ? void 0 : (_flex$parentNode = flex.parentNode) === null || _flex$parentNode === void 0 ? void 0 : _flex$parentNode.removeChild(flex);
  return isSupported;
}
function useFlexGap() {
  var [isFlexGapSupported, setIsFlexGapSupported] = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    if (document.documentElement.classList.contains('flexbox-gap')) {
      setIsFlexGapSupported(true);
    } else if (document.documentElement.classList.contains('no-flexbox-gap')) {
      setIsFlexGapSupported(false);
    }
  }, []);
  return isFlexGapSupported;
}
function useFlexGapPolyfill() {
  (0,react.useLayoutEffect)(() => {
    // first check if it's already been run
    if (!document.documentElement.classList.contains('flexbox-gap') && !document.documentElement.classList.contains('no-flexbox-gap')) {
      if (checkFlexGap()) {
        document.documentElement.classList.add('flexbox-gap');
      } else {
        document.documentElement.classList.add('no-flexbox-gap');
      }
    }
  }, []);
}

// reset margin between direct children
// add extra space before headings
var VerticalRhythmWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "VerticalRhythm__VerticalRhythmWrapper",
  componentId: "lui__sc-z5vadw-0"
})(["display:flex;flex-direction:column;gap:var(--gap);align-items:", ";& > *{margin-top:0;margin-bottom:0;}& > .lui-title1:not(:first-child),& > .lui-title2:not(:first-child),& > .lui-subtitle1:not(:first-child),& > .lui-subtitle2:not(:first-child){margin-top:", "px;}.no-flexbox-gap &{gap:initial;margin-top:calc(var(--gap) / -2);margin-bottom:calc(var(--gap) / -2);> *{margin-top:calc(var(--gap) / 2);margin-bottom:calc(var(--gap) / 2);}& > .lui-title1:not(:first-child),& > .lui-title2:not(:first-child),& > .lui-subtitle1:not(:first-child),& > .lui-subtitle2:not(:first-child){margin-top:calc(calc(var(--gap) / 2) + ", "px);}}"], props => props.align === "start" ? "flex-start" : props.align, commons_esm/* spacing.xs */.W0.xs, commons_esm/* spacing.xs */.W0.xs);

// Direct children have margin removed and are spaced out xs
var VerticalRhythm = _ref => {
  var {
    density = 'md',
    align = 'stretch',
    children
  } = _ref;
  useFlexGapPolyfill();
  var isFlexGapSupported = useFlexGap();
  var gap = "".concat(spacing.md, "px");
  if (density === 'sm') {
    gap = "".concat(spacing.sm, "px");
  } else if (density === 'lg') {
    gap = "".concat(spacing.lg, "px");
  }
  var Markup = /*#__PURE__*/jsx(VerticalRhythmWrapper, {
    className: "vertical-rhythm",
    align: align,
    style: {
      '--gap': gap
    },
    children: children
  });
  return !isFlexGapSupported ? /*#__PURE__*/jsx("div", {
    className: "flex-gap-polyfill-wrapper",
    children: Markup
  }) : Markup;
};

var _excluded$4 = ["width", "xgap", "ygap", "gap", "className", "minWidth", "maxWidth"];
var getYSpacing = props => {
  if (props.ygap) {
    return commons_esm/* spacing */.W0[props.ygap];
  }
  if (props.gap) {
    return commons_esm/* spacing */.W0[props.gap];
  }
  return '0';
};
var getXSpacing = props => {
  if (props.xgap) {
    return commons_esm/* spacing */.W0[props.xgap];
  }
  if (props.gap) {
    return commons_esm/* spacing */.W0[props.gap];
  }
  return '0';
};
var getMarginTop = function getMarginTop(direction, start) {
  var isFlexGapSupported = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!isFlexGapSupported) {
    if (start) {
      return (0,styled_components_browser_esm/* css */.iv)(["margin-top:calc(calc(var(--row-gap) / -2) + ", "px);"], commons_esm/* spacing */.W0[start]);
    }
    return "margin-top: calc(var(--row-gap) / -2);";
  }
  return start && direction === 'column' ? (0,styled_components_browser_esm/* css */.iv)(["margin-top:", "px;"], commons_esm/* spacing */.W0[start]) : null;
};
var getMarginBottom = function getMarginBottom(direction, end) {
  var isFlexGapSupported = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!isFlexGapSupported) {
    if (end) {
      return (0,styled_components_browser_esm/* css */.iv)(["margin-bottom:calc(calc(var(--row-gap) / -2) + ", "px);"], commons_esm/* spacing */.W0[end]);
    }
    return "margin-bottom: calc(var(--row-gap) / -2);";
  }
  return end && direction === 'column' ? (0,styled_components_browser_esm/* css */.iv)(["margin-bottom:", "px;"], commons_esm/* spacing */.W0[end]) : null;
};
var getMarginLeft = (direction, start) => {
  return start && direction === 'row' ? (0,styled_components_browser_esm/* css */.iv)(["margin-left:", "px;"], commons_esm/* spacing */.W0[start]) : null;
};
var getMarginRight = (direction, end) => {
  return end && direction === 'row' ? (0,styled_components_browser_esm/* css */.iv)(["margin-right:", "px;"], commons_esm/* spacing */.W0[end]) : null;
};
var getAlign = align => {
  switch (align) {
    case 'center':
      return "center";
    case 'start':
      return 'flex-start';
    case 'end':
      return 'flex-end';
    case 'stretch':
      return 'stretch';
    default:
      return 'flex-start';
  }
};
var getAlignment = props => {
  if (props.align) {
    return (0,styled_components_browser_esm/* css */.iv)(["justify-content:", ";align-items:", ";"], getAlign(props.align), getAlign(props.align));
  }

  // horizontal spacer
  if (props.direction === 'row') {
    if (props.xalign && props.yalign) {
      return (0,styled_components_browser_esm/* css */.iv)(["justify-content:", ";align-items:", ";"], getAlign(props.yalign), getAlign(props.xalign));
    }
    if (props.xalign) {
      return (0,styled_components_browser_esm/* css */.iv)(["align-items:", ";justify-content:flex-start;"], getAlign(props.xalign));
    }
    if (props.yalign) {
      return (0,styled_components_browser_esm/* css */.iv)(["justify-content:", ";"], getAlign(props.yalign));
    } else {
      return "\n        justify-content: flex-start;\n        align-items: flex-start;\n      ";
    }
  } else {
    // vertical spacer
    if (props.xalign && props.yalign) {
      return (0,styled_components_browser_esm/* css */.iv)(["justify-content:", ";align-items:", ";"], getAlign(props.xalign), getAlign(props.yalign));
    }
    if (props.xalign) {
      return (0,styled_components_browser_esm/* css */.iv)(["justify-content:", ";"], getAlign(props.xalign));
    }
    if (props.yalign) {
      return (0,styled_components_browser_esm/* css */.iv)(["align-items:", ";"], getAlign(props.yalign));
    } else {
      return "\n        justify-content: flex-start;\n        align-items: flex-start;\n      ";
    }
  }
};
var Wrapper$1 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Spacer__Wrapper",
  componentId: "lui__sc-n3gfm-0"
})(["display:flex;flex-direction:", ";column-gap:var(--column-gap);row-gap:var(--row-gap);flex-wrap:", ";width:", ";", " ", " ", " ", " ", " ", " ", " .no-flexbox-gap &{gap:initial;margin-left:calc(var(--column-gap) / -2);margin-right:calc(var(--column-gap) / -2);", " ", " > *{margin-top:calc(var(--row-gap) / 2);margin-bottom:calc(var(--row-gap) / 2);margin-left:calc(var(--column-gap) / 2);margin-right:calc(var(--column-gap) / 2);}}"], props => props.$direction, props => props.shouldWrap ? "wrap" : "nowrap", props => props.$width, props => props.minWidth && "min-width: ".concat(props.minWidth, ";"), props => props.maxWidth && "max-width: ".concat(props.maxWidth, ";"), props => getMarginLeft(props.$direction, props.start), props => getMarginRight(props.$direction, props.$end), props => getMarginTop(props.$direction, props.start), props => getMarginBottom(props.$direction, props.$end), props => getAlignment(props.align ? {
  align: props.align,
  direction: props.$direction
} : {
  xalign: props.xalign,
  yalign: props.yalign,
  direction: props.$direction
}), props => getMarginTop(props.$direction, props.start, false), props => getMarginBottom(props.$direction, props.$end, false));
var FlexGapWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Spacer__FlexGapWrapper",
  componentId: "lui__sc-n3gfm-1"
})(["width:", ";"], props => props.$width);
var index_9102c435_esm_Spacer = _ref => {
  var {
      width = '100%',
      xgap,
      ygap,
      gap,
      className,
      minWidth,
      maxWidth
    } = _ref,
    props = objectWithoutProperties_7e1dfdab_esm_objectWithoutProperties(_ref, _excluded$4);
  var globalProps = (0,commons_esm/* filterGlobalProps */.jC)(props);
  useFlexGapPolyfill();
  var isFlexGapSupported = useFlexGap();
  var direction = 'row';
  var shouldWrap = false;
  if (props !== null && props !== void 0 && props.shouldWrap) {
    shouldWrap = props.shouldWrap;
  } else if (gap) {
    // if we have a gap or both xgap and ygap
    shouldWrap = true;
  } else if (xgap && ygap) {
    shouldWrap = true;
  }

  // if we only have ygap
  if (ygap && !xgap) {
    direction = 'column';
  }

  // or if we have no gap
  if (!xgap && !ygap && !gap) {
    // default to 16
    gap = '16';
  }
  var Markup = /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper$1, (0,index_03130070_esm._)((0,index_03130070_esm._)({
    className: className ? "lui-spacer ".concat(className) : "lui-spacer",
    style: {
      '--row-gap': "".concat(getYSpacing(gap ? {
        gap
      } : {
        xgap,
        ygap
      }), "px"),
      '--column-gap': "".concat(getXSpacing(gap ? {
        gap
      } : {
        xgap,
        ygap
      }), "px")
    },
    $direction: direction,
    align: props.align,
    xalign: props.xalign,
    yalign: props.yalign,
    shouldWrap: shouldWrap,
    $end: props.end,
    $width: width && isFlexGapSupported ? width : 'auto',
    minWidth: minWidth,
    maxWidth: maxWidth,
    start: props.start
  }, isFlexGapSupported && globalProps), {}, {
    children: props.children
  }));
  return !isFlexGapSupported ? /*#__PURE__*/(0,jsx_runtime.jsx)(FlexGapWrapper, (0,index_03130070_esm._)((0,index_03130070_esm._)({
    className: "flex-gap-polyfill-wrapper",
    $width: width
  }, globalProps), {}, {
    children: Markup
  })) : Markup;
};

var _excluded$3 = (/* unused pure expression or super */ null && (["children"]));
var StyledGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Grid__StyledGrid",
  componentId: "lui__sc-1jtonxt-0"
})(["display:flex;flex-wrap:wrap;margin-left:-", ";margin-top:-", ";", "{margin-left:-", ";margin-top:-", ";}> *{padding-left:", ";padding-top:", ";", "{padding-left:", ";padding-top:", ";}}"], index_03130070_esm.G.sm, index_03130070_esm.G.sm, index_03130070_esm.B.sm, index_03130070_esm.G.md, index_03130070_esm.G.md, index_03130070_esm.G.sm, index_03130070_esm.G.sm, index_03130070_esm.B.sm, index_03130070_esm.G.md, index_03130070_esm.G.md);
var Grid = _ref => {
  var {
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$3);
  return /*#__PURE__*/jsx(StyledGrid, _objectSpread2(_objectSpread2({}, props), {}, {
    children: children
  }));
};

var _excluded$2 = (/* unused pure expression or super */ null && (["children"]));
var SmallScreenGrid = '4';
var LargeScreenGrid = '12';
var calculatePercentage = (partial, total) => "".concat(Number(partial) / Number(total) * 100, "%");
var getWidth = (size, totalColumns) => {
  if (!size) return;
  if (size === 'auto') {
    return 'auto';
  } else {
    return calculatePercentage(size, totalColumns);
  }
};
var StyledGridItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "GridItem__StyledGridItem",
  componentId: "lui__sc-y5ttjj-0"
})(["max-width:100%;width:", ";", " ", "{flex:0 0 auto;width:", ";}", "{flex:0 0 auto;width:", ";}", "{flex:0 0 auto;width:", ";}", "{flex:0 0 auto;width:", ";}"], _ref => {
  var {
    xs
  } = _ref;
  return xs ? getWidth(xs, SmallScreenGrid) : '100%';
}, _ref2 => {
  var {
    xs
  } = _ref2;
  return xs ? (0,styled_components_browser_esm/* css */.iv)(["flex:0 0 auto;"]) : (0,styled_components_browser_esm/* css */.iv)(["flex-shrink:0;"]);
}, index_03130070_esm.B.sm, _ref3 => {
  var {
    sm
  } = _ref3;
  return getWidth(sm, LargeScreenGrid);
}, index_03130070_esm.B.md, _ref4 => {
  var {
    md
  } = _ref4;
  return getWidth(md, LargeScreenGrid);
}, index_03130070_esm.B.lg, _ref5 => {
  var {
    lg
  } = _ref5;
  return getWidth(lg, LargeScreenGrid);
}, index_03130070_esm.B.xl, _ref6 => {
  var {
    xl
  } = _ref6;
  return getWidth(xl, LargeScreenGrid);
});
var GridItem = _ref7 => {
  var {
      children
    } = _ref7,
    props = _objectWithoutProperties(_ref7, _excluded$2);
  return /*#__PURE__*/jsx(StyledGridItem, _objectSpread2(_objectSpread2({}, props), {}, {
    children: children
  }));
};

var _excluded$1 = (/* unused pure expression or super */ null && (["children"]));
var MaxWidths = {
  xxl: '82.5rem',
  // 1320px
  xl: '71.25rem' // 1140px
};

var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Wrapper__StyledWrapper",
  componentId: "lui__sc-5zleyr-0"
})(["max-width:", ";margin-left:auto;margin-right:auto;padding-left:", ";padding-right:", ";@media (min-width:", "){padding-left:", ";padding-right:", ";}"], _ref => {
  var {
    maxWidth
  } = _ref;
  return maxWidth ? MaxWidths[maxWidth] : MaxWidths.xxl;
}, index_03130070_esm.G.sm, index_03130070_esm.G.sm, index_03130070_esm.a.sm, index_03130070_esm.G.md, index_03130070_esm.G.md);
var Wrapper = _ref2 => {
  var {
      children
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded$1);
  return /*#__PURE__*/jsx(StyledWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: children
  }));
};

var _excluded = (/* unused pure expression or super */ null && (["children"]));
var StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Section__StyledSection",
  componentId: "lui__sc-1pbxoat-0"
})(["padding-top:3rem;padding-bottom:3rem;", "{padding-top:4rem;padding-bottom:4rem;}", "{padding-top:6rem;padding-bottom:6rem;}"], index_03130070_esm.B.sm, index_03130070_esm.B.lg);
var Section = _ref => {
  var {
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(StyledSection, _objectSpread2(_objectSpread2({}, props), {}, {
    children: children
  }));
};



// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/commons/typography/dist/commons.esm.js
var dist_commons_esm = __webpack_require__(70757);
;// CONCATENATED MODULE: ../node_modules/@lendi/ui/dist/RichText-50b4a7f5.esm.js








var getFontSize = variant => {
  var styles = styleData[variant];
  return styles.fontSize;
};
var getLineHeight = variant => {
  var styles = styleData[variant];
  return styles.lineHeight;
};
var getTextColor = (theme, appearance) => {
  if (appearance) {
    if (appearance === 'error') {
      return theme.color.interaction.error;
    }
    if (appearance === 'subtle') {
      return theme.color.text.subtle;
    }
  }
  return theme.color.text.main;
};
var linkStyle = theme => {
  return {
    textDecoration: 'underline',
    color: theme.color.interaction.main,
    fontFamily: theme.asset.font.body.family,
    '&:hover': {
      textDecoration: 'none'
    }
  };
};
var styleData = {
  display: {
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(36),
      desktop: (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[10])
    },
    lineHeight: 1.31
  },
  display1: {
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[9]),
      desktop: (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[10])
    },
    lineHeight: index_03130070_esm.L.heading
  },
  display2: {
    hasMobile: true,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[8]),
      desktop: (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[9])
    },
    lineHeight: index_03130070_esm.L.heading
  },
  title1: {
    hasMobile: true,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[7]),
      desktop: (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[8])
    },
    lineHeight: index_03130070_esm.L.heading
  },
  title2: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[6])
    },
    lineHeight: index_03130070_esm.L.heading
  },
  title3: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[5])
    },
    lineHeight: index_03130070_esm.L.heading
  },
  title4: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[4])
    },
    lineHeight: index_03130070_esm.L.heading
  },
  lead1: {
    hasMobile: true,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[5]),
      desktop: (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[6])
    },
    lineHeight: index_03130070_esm.L.body
  },
  lead2: {
    hasMobile: true,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[3]),
      desktop: (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[5])
    },
    lineHeight: index_03130070_esm.L.body
  },
  subtitle1: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[3])
    },
    lineHeight: index_03130070_esm.L.body
  },
  subtitle2: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[2])
    },
    lineHeight: index_03130070_esm.L.body
  },
  body1: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[3])
    },
    lineHeight: index_03130070_esm.L.body
  },
  body2: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[2])
    },
    lineHeight: index_03130070_esm.L.body
  },
  detail1: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[1])
    },
    lineHeight: index_03130070_esm.L.body
  },
  detail2: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[1])
    },
    lineHeight: index_03130070_esm.L.body
  },
  overline: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[2])
    },
    lineHeight: index_03130070_esm.L.heading
  },
  button1: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[3])
    },
    lineHeight: index_03130070_esm.L.body
  },
  button2: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[2])
    },
    lineHeight: index_03130070_esm.L.body
  }
};

var RichText_50b4a7f5_esm_excluded$1 = ["children", "variant", "className"];
var getThemeTextAlignment = themeName => {
  if (themeName === commons_esm/* ThemeNames.Lendi */.hN.Lendi) {
    return 'center';
  }
  return 'left';
};
var checkIsHeading = variant => {
  var headingsVariants = ['display', 'display1', 'display2', 'title1', 'title2', 'title3', 'title4'];
  return headingsVariants.includes(variant);
};
var Component = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "Text__Component",
  componentId: "lui__sc-xe5utb-0"
})(_ref => {
  var _theme$name;
  var {
    variant,
    theme,
    align,
    isMobile,
    styleTarget,
    $display,
    appearance,
    isInverse
  } = _ref;
  var fontSizeValue = getFontSize(variant);
  var isHeading = checkIsHeading(variant);
  var hasDesktopFontSize = Object.prototype.hasOwnProperty.call(fontSizeValue, 'desktop');
  var themeName = (_theme$name = theme === null || theme === void 0 ? void 0 : theme.name) !== null && _theme$name !== void 0 ? _theme$name : (0,commons_esm/* getThemeName */.Yo)(); // fallback to old getTheme function when latest Theme not being used. To be removed in next major

  var styleObj = {
    margin: 0,
    display: $display !== null && $display !== void 0 ? $display : 'block',
    fontFamily: isHeading ? theme.asset.font.heading.family : theme.asset.font.body.family,
    fontWeight: (0,dist_commons_esm/* default */.Z)(variant, 'fontWeight'),
    textAlign: align !== null && align !== void 0 ? align : getThemeTextAlignment(themeName),
    color: isInverse ? theme.color.text.inverse : getTextColor(theme, appearance),
    fontSize: fontSizeValue.mobile,
    lineHeight: getLineHeight(variant),
    a: linkStyle(theme)
  };
  if (variant === 'overline') {
    styleObj = Object.assign({
      textTransform: 'uppercase',
      letterSpacing: '0.05em'
    }, styleObj);
  }
  if (hasDesktopFontSize && !isMobile) {
    styleObj = Object.assign({
      [index_03130070_esm.B.sm]: {
        fontSize: fontSizeValue.desktop
      }
    }, styleObj);
  }
  if (styleTarget) {
    return {
      [styleTarget]: styleObj
    };
  }
  return styleObj;
});
var RichText_50b4a7f5_esm_Text = _ref2 => {
  var {
      children,
      variant = 'body1',
      className
    } = _ref2,
    props = objectWithoutProperties_7e1dfdab_esm_objectWithoutProperties(_ref2, RichText_50b4a7f5_esm_excluded$1);
  var globalProps = (0,commons_esm/* filterGlobalProps */.jC)(props);
  var textVariantClass;
  switch (variant) {
    case 'display':
      textVariantClass = 'lui-display';
      break;
    case 'display1':
      textVariantClass = 'lui-display1';
      break;
    case 'display2':
      textVariantClass = 'lui-display2';
      break;
    case 'title1':
      textVariantClass = 'lui-title1';
      break;
    case 'title2':
      textVariantClass = 'lui-title2';
      break;
    case 'title3':
      textVariantClass = 'lui-title3';
      break;
    case 'title4':
      textVariantClass = 'lui-title4';
      break;
    case 'lead1':
      textVariantClass = 'lui-lead1';
      break;
    case 'lead2':
      textVariantClass = 'lui-lead2';
      break;
    case 'subtitle1':
      textVariantClass = 'lui-subtitle1';
      break;
    case 'subtitle2':
      textVariantClass = 'lui-subtitle2';
      break;
    case 'body1':
      textVariantClass = 'lui-body1';
      break;
    case 'body2':
      textVariantClass = 'lui-body2';
      break;
    case 'button1':
      textVariantClass = 'lui-button1';
      break;
    case 'button2':
      textVariantClass = 'lui-button2';
      break;
    case 'detail1':
      textVariantClass = 'lui-detail1';
      break;
    case 'detail2':
      textVariantClass = 'lui-detail2';
      break;
    case 'overline':
      textVariantClass = 'lui-overline';
      break;
    default:
      textVariantClass = 'lui-body1';
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, (0,index_03130070_esm._)((0,index_03130070_esm._)({
    id: props.id,
    className: className ? "".concat(className, " ").concat(textVariantClass) : textVariantClass,
    as: props.tag,
    variant: variant,
    align: props.align,
    appearance: props.appearance,
    isMobile: props.isMobile,
    htmlFor: props.for,
    $display: props.display,
    role: props.role,
    isInverse: props.isInverse
  }, globalProps), {}, {
    children: children
  }));
};

var Paragraph = (0,styled_components_browser_esm/* default */.ZP)(RichText_50b4a7f5_esm_Text).withConfig({
  displayName: "Paragraph",
  componentId: "lui__sc-iqzapc-0"
})(_ref => {
  var {
    theme
  } = _ref;
  return {
    a: linkStyle(theme)
  };
});
var P = _ref2 => {
  var {
    appearance,
    variant,
    children
  } = _ref2;
  return /*#__PURE__*/jsx(Paragraph, {
    variant: variant !== null && variant !== void 0 ? variant : 'body1',
    tag: "p",
    appearance: appearance,
    children: children
  });
};

var A = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "Link__A",
  componentId: "lui__sc-1u7drzy-0"
})(["", ""], _ref => {
  var {
    theme
  } = _ref;
  return linkStyle(theme);
});

var RichText_50b4a7f5_esm_excluded = (/* unused pure expression or super */ null && (["children", "textSize"]));
var StyledRichText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RichText__StyledRichText",
  componentId: "lui__sc-nganh6-0"
})(["font-size:", ";line-height:", ";color:", ";", "{font-size:", ";}> *{font-family:", ";font-weight:", ";font-size:1em;margin-bottom:0;margin-top:0;}> * + *{margin-top:", ";", "{margin-top:", ";}}> * li{margin-top:0.5em;}> * + h1,> * + h2,> * + div,> div + *{margin-top:", ";}> h1 + *,> h2 + *{margin-top:", ";}> h3 + *,> h4 + *{margin-top:", ";}> * + h3,> * + h4{margin-top:", ";}> h1,> h2,> h3,> h4{font-family:", ";line-height:", ";font-weight:", ";color:", ";}> h1{font-size:", ";", ";}> h2{font-size:", ";", ";}> h3{font-size:", ";}> h4{font-size:", ";}> a,li > a,p > a{", ";}"], (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.b), styleData.body1.lineHeight, _ref => {
  var {
    theme
  } = _ref;
  return theme.color.text.subtle;
}, index_03130070_esm.B.sm, _ref2 => {
  var {
    textSize
  } = _ref2;
  return textSize === 'lg' && (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[5]);
}, _ref3 => {
  var {
    theme
  } = _ref3;
  return theme.asset.font.body.family;
}, _ref4 => {
  var {
    theme
  } = _ref4;
  return theme.asset.font.body.weight;
}, (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[3]), index_03130070_esm.B.sm, _ref5 => {
  var {
    textSize
  } = _ref5;
  return textSize === 'lg' && (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[5]);
}, (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[10]), (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[6]), (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[5]), (0,commons_esm/* pxToRem */.Q1)(index_03130070_esm.f[9]), _ref6 => {
  var {
    theme
  } = _ref6;
  return theme.asset.font.body.family;
}, index_03130070_esm.L.heading, _ref7 => {
  var {
    theme
  } = _ref7;
  return theme.asset.font.heading.weight;
}, _ref8 => {
  var {
    theme
  } = _ref8;
  return theme.color.text.main;
}, styleData.display2.fontSize.mobile, 'desktop' in styleData.display2.fontSize && (0,styled_components_browser_esm/* css */.iv)(["", "{font-size:", ";}"], index_03130070_esm.B.sm, styleData.display2.fontSize.desktop), styleData.title1.fontSize.mobile, 'desktop' in styleData.title1.fontSize && (0,styled_components_browser_esm/* css */.iv)(["", "{font-size:", ";}"], index_03130070_esm.B.sm, styleData.title1.fontSize.desktop), styleData.title2.fontSize.mobile, styleData.title3.fontSize.mobile, _ref9 => {
  var {
    theme
  } = _ref9;
  return linkStyle(theme);
});

// Direct children have margin removed and are spaced out xs
var RichText = _ref10 => {
  var {
      children,
      textSize = 'md'
    } = _ref10,
    props = _objectWithoutProperties(_ref10, RichText_50b4a7f5_esm_excluded);
  return /*#__PURE__*/jsx(StyledRichText, _objectSpread2(_objectSpread2({
    textSize: textSize
  }, props), {}, {
    children: children
  }));
};



// EXTERNAL MODULE: ../node_modules/@lendi/ui/dist/select-73d530a0.esm.js + 1 modules
var select_73d530a0_esm = __webpack_require__(36437);
// EXTERNAL MODULE: ../node_modules/@lendi/ui/dist/index-83c6f867.esm.js
var index_83c6f867_esm = __webpack_require__(38570);
;// CONCATENATED MODULE: ../node_modules/@lendi/ui/dist/index.style-741fda20.esm.js


/**
 * This is a 100% duplicate of `@lendi-ui/icon/spinner`.
 *
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
var index_style_741fda20_esm_IconWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "indexstyle__IconWrapper",
  componentId: "lui__sc-1vln477-0"
})(["width:", ";height:", ";vertical-align:middle;display:inline-block;& > svg{fill:", ";width:inherit;height:inherit;}[class$='fillPath']{fill:", ";}"], _ref => {
  var {
    width
  } = _ref;
  return width !== null && width !== void 0 ? width : '1em';
}, _ref2 => {
  var {
    height
  } = _ref2;
  return height !== null && height !== void 0 ? height : '1em';
}, _ref3 => {
  var {
    color
  } = _ref3;
  return color;
}, _ref4 => {
  var {
    color
  } = _ref4;
  return color;
});



// EXTERNAL MODULE: ../../../node_modules/react-helmet/es/Helmet.js
var Helmet = __webpack_require__(74758);
// EXTERNAL MODULE: ../../../node_modules/react-element-to-jsx-string/dist/cjs/index.js
var cjs = __webpack_require__(44782);
// EXTERNAL MODULE: ../../../node_modules/@testing-library/react/dist/@testing-library/react.esm.js + 1 modules
var react_esm = __webpack_require__(72720);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/commons/borders/dist/commons.esm.js
var borders_dist_commons_esm = __webpack_require__(53075);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/commons/depth/dist/commons.esm.js
var depth_dist_commons_esm = __webpack_require__(46706);
;// CONCATENATED MODULE: ../node_modules/@lendi/ui/dist/AnchorButton-86ecf1ec.esm.js















var getIconMargin = props => {
  var marginSize;
  switch (props.size) {
    case 'lg':
      marginSize = "".concat((0,commons_esm/* pxToRem */.Q1)(20));
      break;
    case 'sm':
      marginSize = "".concat((0,commons_esm/* pxToRem */.Q1)(8));
      break;
    case 'xs':
      marginSize = "".concat((0,commons_esm/* pxToRem */.Q1)(6));
      break;
    default:
    case 'md':
      marginSize = "".concat((0,commons_esm/* pxToRem */.Q1)(12));
  }
  return (0,styled_components_browser_esm/* css */.iv)(["", ""], props.position === 'start' ? "margin-right: ".concat(marginSize, ";") : props.position === 'end' ? "margin-left: ".concat(marginSize, ";") : '');
};
var AnchorButton_86ecf1ec_esm_IconWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Icon__IconWrapper",
  componentId: "lui__sc-1c5jz0y-0"
})(["display:inline-flex;", " ", ""], _ref => {
  var {
    position,
    size
  } = _ref;
  return getIconMargin({
    size,
    position
  });
}, props => props.isLoading && (0,styled_components_browser_esm/* css */.iv)(["visibility:hidden;"]));
var Icon = _ref2 => {
  var {
    isLoading,
    icon,
    position,
    size
  } = _ref2;
  var IconComponent = icon === null || icon === void 0 ? void 0 : icon.component;
  var isSmall = size === 'xs';
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AnchorButton_86ecf1ec_esm_IconWrapper, {
    size: size,
    position: position,
    isLoading: isLoading,
    "aria-hidden": true,
    children: IconComponent && /*#__PURE__*/(0,jsx_runtime.jsx)(IconComponent, {
      height: isSmall ? '1.43em' : '1.5em',
      width: "auto"
    })
  });
};

var ButtonContent = _ref => {
  var {
    isLoading,
    icon,
    children,
    size
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [icon && icon.position !== 'end' && /*#__PURE__*/(0,jsx_runtime.jsx)(Icon, {
      size: size,
      isLoading: isLoading,
      icon: icon,
      position: icon.position
    }), children && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      style: isLoading ? {
        visibility: 'hidden'
      } : undefined,
      children: children
    }), icon && icon.position === 'end' && /*#__PURE__*/(0,jsx_runtime.jsx)(Icon, {
      size: size,
      isLoading: isLoading,
      icon: icon,
      position: icon.position
    })]
  });
};

/**
 * This is a 100% duplicate of `@lendi-ui/icon/spinner`.
 *
 * It is used in LUI Next Button
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
function SpinnerIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_style_741fda20_esm_IconWrapper, (0,index_03130070_esm._)((0,index_03130070_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M10.088.584v3c2.96 0 5.062 1.734 6.006 4.014.944 2.28.682 4.99-1.41 7.082-2.093 2.092-4.803 2.354-7.082 1.41-2.28-.944-4.014-3.047-4.014-6.006h-3c0 4.168 2.576 7.415 5.865 8.777 3.289 1.362 7.406.889 10.354-2.058 2.947-2.947 3.42-7.065 2.058-10.354C17.503 3.16 14.256.584 10.088.584z"
      })
    })
  }));
}

/**
 * This is a 100% duplicate of `@lendi-ui/spinner`.
 *
 * It is duplicated so that, mono-package can be rid of LUI Now Color.
 *
 * @param variant
 * @constructor
 */
var spin = (0,styled_components_browser_esm/* keyframes */.F4)(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
var SpinnerIconWrapper = (0,styled_components_browser_esm/* default */.ZP)(SpinnerIcon).withConfig({
  displayName: "indexstyle__SpinnerIconWrapper",
  componentId: "lui__sc-ilwsxi-0"
})(["animation:", " 1.2s linear infinite;display:flex;line-height:0;width:100%;height:100%;svg{fill:currentColor;}"], spin);

/**
 * This is a 100% duplicate of `@lendi-ui/spinner`.
 *
 * It is duplicated so that, mono-package can be rid of LUI Now Color.
 *
 * @param variant
 * @constructor
 */
var Spinner = _ref => {
  var {
    variant = 'dark'
  } = _ref;
  var theme = (0,index_83c6f867_esm.u)();
  var color = variant === 'dark' ? theme.color.buttonForeground.default : 'white';
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SpinnerIconWrapper, {
    color: color
  });
};

var BaseButtonStyles = (0,styled_components_browser_esm/* css */.iv)(["display:inline-block;text-align:center;position:relative;transition:background-color 0.2s ease-out,color 0.2s ease-out,box-shadow 0.2s ease-out;cursor:pointer;font-family:", ";font-weight:700;border:solid 2px transparent;:focus-visible{outline:solid 2px ", ";outline-offset:2px;}:disabled{cursor:default;pointer-events:none;}"], _ref => {
  var {
    theme
  } = _ref;
  return theme.asset.font.body.family;
}, _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.color.border.interaction.focus;
});
var getButtonSize = props => {
  var _props$minWidth;
  var minWidth;
  var padding;

  /**
   * @todo Tokens: font-size
   */
  var fontSizeValue = props.size === 'xs' ? 14 : 16;
  var lineHeightValue = props.size === 'xs' ? 1.43 : 1.5;
  switch (props.size) {
    case 'lg':
      padding = "".concat((0,commons_esm/* pxToRem */.Q1)(18), " ").concat((0,commons_esm/* pxToRem */.Q1)(40));
      minWidth = (0,commons_esm/* pxToRem */.Q1)(144);
      break;
    case 'sm':
      padding = "".concat((0,commons_esm/* pxToRem */.Q1)(6), " ").concat((0,commons_esm/* pxToRem */.Q1)(14));
      minWidth = (0,commons_esm/* pxToRem */.Q1)(90);
      break;
    case 'xs':
      padding = "".concat((0,commons_esm/* pxToRem */.Q1)(4), " ").concat((0,commons_esm/* pxToRem */.Q1)(10));
      minWidth = (0,commons_esm/* pxToRem */.Q1)(72);
      break;
    default:
    case 'md':
      padding = "".concat((0,commons_esm/* pxToRem */.Q1)(10), " ").concat((0,commons_esm/* pxToRem */.Q1)(22));
      minWidth = (0,commons_esm/* pxToRem */.Q1)(108);
  }
  return (0,styled_components_browser_esm/* css */.iv)(["", ";", ";min-width:", ";padding:", ";border-radius:", ";font-size:", ";line-height:", ";"], props.width ? "width: ".concat(props.width) : '', props.maxWidth ? "max-width: ".concat(props.maxWidth) : '', (_props$minWidth = props.minWidth) !== null && _props$minWidth !== void 0 ? _props$minWidth : minWidth, padding, (0,borders_dist_commons_esm/* getRadius */.H5)('button'), (0,commons_esm/* pxToRem */.Q1)(fontSizeValue), lineHeightValue);
};
var getColorStyle = (variant, state) => {
  return (0,styled_components_browser_esm/* css */.iv)(["background-color:", ";color:", ";border-color:", ";"], _ref3 => {
    var {
      theme
    } = _ref3;
    return theme.color.buttonFill[variant][state];
  }, _ref4 => {
    var {
      theme
    } = _ref4;
    return theme.color.buttonForeground[variant][state];
  }, _ref5 => {
    var {
      theme
    } = _ref5;
    return theme.color.buttonBorder[variant][state];
  });
};

//
// OLD LENDI BUTTON STYLES
// This will be removed, this code is here to bridge the gap untill lendi theme is turned off
//
var getOldLendiStyles = (variantName, isInverse) => (0,styled_components_browser_esm/* css */.iv)(["text-transform:uppercase;letter-spacing:1.2px;border-width:1px;", ";&:disabled{opacity:0.4;}&:hover{box-shadow:", ";", ";}&:active{box-shadow:none;}:focus-visible{outline:0;box-shadow:", ",", ";}"], variantName.includes('text') ? "text-decoration: none; " : '', (0,depth_dist_commons_esm/* default */.Z)(4), variantName.includes('text') && !isInverse ? "box-shadow: ".concat((0,depth_dist_commons_esm/* default */.Z)(3)) : '', (0,borders_dist_commons_esm/* getFocusRing */.yb)(), (0,depth_dist_commons_esm/* default */.Z)(2, 'focusRing'));
var StyledButtonBase = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "buttonstyles__StyledButtonBase",
  componentId: "lui__sc-1juyc07-0"
})(["", ";", ";", ""], BaseButtonStyles, props => getButtonSize(props), _ref6 => {
  var {
    isInverse,
    variant
  } = _ref6;
  var variantName = isInverse ? "".concat(variant, "Inverse") : variant;
  return (0,styled_components_browser_esm/* css */.iv)(["", ";", " &:disabled{", ";pointer-events:none;}&:hover{", ";", "}&:focus-visible{", ";", "}&:active{", ";transform:translateY(1px);", "}", ";"], getColorStyle(variantName, 'default'), variantName.includes('text') && "text-decoration: underline;", getColorStyle(variantName, 'disabled'), getColorStyle(variantName, 'hover'), variantName.includes('text') && "text-decoration: none;", getColorStyle(variantName, 'focus'), variantName.includes('text') && "text-decoration: none;", getColorStyle(variantName, 'pressed'), variantName.includes('text') && "text-decoration: none;", _ref7 => {
    var {
      theme
    } = _ref7;
    return theme.name === 'lendi' && getOldLendiStyles(variantName, isInverse);
  });
});

var AnchorButton_86ecf1ec_esm_excluded$1 = ["variant", "width", "size", "ariaExpanded", "ariaLabel", "className", "isInverse", "minWidth", "maxWidth", "isLoading", "isDisabled", "icon", "children", "onPress", "onClick", "type"];
var Loader = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Button__Loader",
  componentId: "lui__sc-12k3xs9-0"
})(["position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);display:flex;width:", ";height:", ";"], _ref => {
  var {
    size
  } = _ref;
  return size === 'xs' ? '1.43em' : '1.5em';
}, _ref2 => {
  var {
    size
  } = _ref2;
  return size === 'xs' ? '1.43em' : '1.5em';
});
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(StyledButtonBase).withConfig({
  displayName: "Button__StyledButton",
  componentId: "lui__sc-12k3xs9-1"
})(["", ";"], _ref3 => {
  var {
    icon
  } = _ref3;
  return icon && "display: inline-flex; align-items: center; justify-content: center;";
});
var Button = _ref4 => {
  var {
      variant = 'primary',
      width = 'auto',
      size = 'md',
      ariaExpanded,
      ariaLabel,
      className,
      isInverse,
      minWidth,
      maxWidth,
      isLoading,
      isDisabled,
      icon,
      children,
      onPress,
      onClick,
      type = 'button'
    } = _ref4,
    props = objectWithoutProperties_7e1dfdab_esm_objectWithoutProperties(_ref4, AnchorButton_86ecf1ec_esm_excluded$1);
  var globalProps = (0,commons_esm/* filterGlobalProps */.jC)(props);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledButton, (0,index_03130070_esm._)((0,index_03130070_esm._)({
    size: size,
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth,
    isInverse: isInverse,
    "aria-label": ariaLabel,
    "aria-expanded": ariaExpanded,
    className: className,
    onClick: onClick !== null && onClick !== void 0 ? onClick : onPress,
    variant: variant,
    type: type,
    isLoading: isLoading,
    disabled: isDisabled,
    icon: icon
  }, globalProps), {}, {
    children: [isLoading && /*#__PURE__*/(0,jsx_runtime.jsxs)(Loader, {
      size: size,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spinner, {
        variant: variant === 'primary' ? 'light' : 'dark'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "sr-only",
        children: "Loading"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonContent, {
      size: size,
      isLoading: isLoading,
      icon: icon,
      children: children
    })]
  }));
};

var AnchorButton_86ecf1ec_esm_excluded = (/* unused pure expression or super */ null && (["href", "target", "variant", "width", "isInverse", "ariaLabel", "minWidth", "maxWidth", "onPress", "onClick", "children", "className", "icon", "size"]));
var StyledAnchorButton = (0,styled_components_browser_esm/* default */.ZP)(StyledButtonBase).withConfig({
  displayName: "AnchorButton__StyledAnchorButton",
  componentId: "lui__sc-6oc08b-0"
})(["", ";text-decoration:none;"], _ref => {
  var {
    icon
  } = _ref;
  return icon && "display: inline-flex; align-items: center; justify-content: center;";
});
var AnchorButton = _ref2 => {
  var {
      href,
      target,
      variant = 'primary',
      width,
      isInverse,
      ariaLabel,
      minWidth,
      maxWidth,
      onPress,
      onClick,
      children,
      className,
      icon,
      size = 'md'
    } = _ref2,
    props = _objectWithoutProperties(_ref2, AnchorButton_86ecf1ec_esm_excluded);
  var globalProps = filterGlobalProps(props);
  return /*#__PURE__*/jsx(StyledAnchorButton, _objectSpread2(_objectSpread2({
    as: "a",
    size: size,
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth,
    isInverse: isInverse,
    "aria-label": ariaLabel,
    className: className,
    variant: variant,
    href: href,
    target: target,
    icon: icon,
    rel: target === '_blank' ? 'noopener noreferrer' : undefined,
    onClick: onClick !== null && onClick !== void 0 ? onClick : onPress
  }, globalProps), {}, {
    children: /*#__PURE__*/jsx(ButtonContent, {
      size: size,
      icon: icon,
      children: children
    })
  }));
};



// EXTERNAL MODULE: ../../../node_modules/cuid/index.js
var node_modules_cuid = __webpack_require__(56219);
;// CONCATENATED MODULE: ../node_modules/@lendi/ui/dist/TextField-a97ed0b9.esm.js


















/**
 * This is a 100% duplicate of `@lendi-ui/icon/email`.
 *
 * It is used in LUI Next TextField
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
function SvgEmail(props) {
  return /*#__PURE__*/jsx(IconWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/jsx("path", {
        d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
      }), /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })]
    })
  }));
}

var InputBaseComponent = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "InputBase__InputBaseComponent",
  componentId: "lui__sc-ncc05m-0"
})(["font-family:", ";font-size:", ";color:", ";background-color:", ";border:", ";border-radius:", ";padding:", ";height:", ";width:100%;&:hover{", ";}&::placeholder{color:", ";}&:focus-visible{outline:0;box-shadow:", ";}&:disabled{background-color:", ";border:1px solid ", ";&::placeholder{color:", ";}}"], _ref => {
  var {
    theme
  } = _ref;
  return theme.asset.font.body.family;
}, (0,commons_esm/* pxToRem */.Q1)(16), _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.color.text.main;
}, _ref3 => {
  var {
    theme
  } = _ref3;
  return theme.color.background.container;
}, _ref4 => {
  var {
    validationState,
    theme
  } = _ref4;
  return validationState === 'invalid' ? "2px solid ".concat(theme.color.interaction.error) : "1px solid ".concat(theme.color.border.interaction.default);
}, () => (0,borders_dist_commons_esm/* getRadius */.H5)(), (0,commons_esm/* pxToRem */.Q1)(16), (0,commons_esm/* pxToRem */.Q1)(48), _ref5 => {
  var {
    validationState,
    theme
  } = _ref5;
  return validationState !== 'invalid' && "border: 1px solid ".concat(theme.color.border.interaction.hover);
}, _ref6 => {
  var {
    theme
  } = _ref6;
  return theme.color.text.main;
}, (0,borders_dist_commons_esm/* getFocusRing */.yb)(), _ref7 => {
  var {
    theme
  } = _ref7;
  return theme.color.fill.disabled;
}, _ref8 => {
  var {
    theme
  } = _ref8;
  return theme.color.interaction.disabled;
}, _ref9 => {
  var {
    theme
  } = _ref9;
  return theme.color.interaction.disabled;
});

/**
 * This is a 100% duplicate of `@lendi-ui/icon/clear`.
 *
 * It is used in LUI Next TextField
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
function SvgClear(props) {
  return /*#__PURE__*/jsx(IconWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/jsx("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
      }), /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })]
    })
  }));
}

function TextField_a97ed0b9_esm_useClearAction(onChange, ref, value) {
  var [isCleared, setIsCleared] = useState(false);
  useEffect(() => {
    var inputRef = ref;

    // When the component first renders, check if value is empty
    if (inputRef !== null && inputRef !== void 0 && inputRef.current && inputRef.current.value === '') {
      setIsCleared(true);
    } else if (value === '') {
      setIsCleared(true);
    }

    // When we have cleared, set value for uncontrolled inputs
    if (inputRef !== null && inputRef !== void 0 && inputRef.current && isCleared) {
      inputRef.current.value = '';
    }
  }, [isCleared, ref, value]);
  var clearValue = () => {
    setIsCleared(true);
  };
  var handleChange = e => {
    if (e.target.value === '') {
      setIsCleared(true);
    } else {
      // once a value has been typed, we are no longer clearing
      setIsCleared(false);
    }
    // call the consumer's onChange
    if (onChange) {
      onChange(e);
    }
  };
  return {
    clearValue,
    handleChange,
    isCleared
  };
}

// TODO: this should be our button component
// ^^^ Until Button allows className we can't do that
var ActionButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "ClearAction__ActionButton",
  componentId: "lui__sc-1cpgla3-0"
})(["position:absolute;right:", ";top:", ";border:0;border-radius:", ";background:none;padding:", ";cursor:pointer;&:focus-visible{outline:0;box-shadow:", ";}"], (0,commons_esm/* pxToRem */.Q1)(6), (0,commons_esm/* pxToRem */.Q1)(7), (0,commons_esm/* pxToRem */.Q1)(4), (0,commons_esm/* pxToRem */.Q1)(5), (0,borders_dist_commons_esm/* getFocusRing */.yb)());
var TextField_a97ed0b9_esm_ClearActionButton = _ref => {
  var {
    isCleared,
    clearValue
  } = _ref;
  var theme = useTheme();
  if (isCleared) {
    return null;
  } else {
    return /*#__PURE__*/jsx(ActionButton, {
      "aria-label": "Clear",
      type: "button",
      onClick: clearValue,
      children: /*#__PURE__*/jsx(SvgClear, {
        color: theme.color.interaction.contrast,
        width: "24px",
        height: "24px"
      })
    });
  }
};

/**
 * This is a 100% duplicate of `@lendi-ui/icon/error`.
 *
 * It is used in LUI Next TextField
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
function SvgError(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_style_741fda20_esm_IconWrapper, (0,index_03130070_esm._)((0,index_03130070_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
      })]
    })
  }));
}

var ErrorIcon = (0,styled_components_browser_esm/* default */.ZP)(SvgError).withConfig({
  displayName: "ErrorText__ErrorIcon",
  componentId: "lui__sc-1xismmk-0"
})(["display:inline;"]);
var TextField_a97ed0b9_esm_ErrorText = _ref => {
  var {
    id,
    text
  } = _ref;
  var theme = useTheme();
  return /*#__PURE__*/jsxs(Spacer, {
    xgap: "xxs",
    children: [/*#__PURE__*/jsx(ErrorIcon, {
      color: theme.color.interaction.error
    }), /*#__PURE__*/jsx(Text, {
      id: id,
      tag: "p",
      variant: "detail1",
      appearance: "error",
      display: "flex",
      children: text
    })]
  });
};

var TextField_a97ed0b9_esm_HelpText = _ref => {
  var {
    id,
    text
  } = _ref;
  return /*#__PURE__*/jsx(Text, {
    id: id,
    tag: "p",
    variant: "detail2",
    appearance: "subtle",
    children: text
  });
};

var TextField_a97ed0b9_esm_FieldLabel = _ref => {
  var {
    tag = 'label',
    label,
    labelSuffix,
    forId
  } = _ref;
  var LabelComponent = label;
  var props = {};
  if (tag === 'label') {
    props = {
      for: forId
    };
  }
  return /*#__PURE__*/jsxs(Text, _objectSpread2(_objectSpread2({
    variant: "subtitle2",
    tag: tag
  }, props), {}, {
    children: [typeof label === 'string' ? label : /*#__PURE__*/jsx(LabelComponent, {}), labelSuffix && " ".concat(labelSuffix)]
  }));
};

var TextField_a97ed0b9_esm_excluded = (/* unused pure expression or super */ null && (["inputId", "name", "variant", "value", "defaultValue", "onChange", "validationState", "label", "ariaLabel", "ariaLabelledBy", "labelSuffix", "inlineAction", "autoComplete", "placeholder", "helpText", "errorText", "isDisabled", "isRequired", "maxCharCount", "minCharCount", "width", "minWidth", "maxWidth"]));
var Input = (0,styled_components_browser_esm/* default */.ZP)(InputBaseComponent).withConfig({
  displayName: "TextField__Input",
  componentId: "lui__sc-1h9z42q-0"
})(["padding-left:", ";padding-right:", ";"], props => props.hasLeftItem ? (0,commons_esm/* pxToRem */.Q1)(46) : (0,commons_esm/* pxToRem */.Q1)(16), props => props.hasRightItem ? (0,commons_esm/* pxToRem */.Q1)(46) : (0,commons_esm/* pxToRem */.Q1)(16));
var TextField_a97ed0b9_esm_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TextField__Wrapper",
  componentId: "lui__sc-1h9z42q-1"
})(["position:relative;width:100%;"]);
var LeftIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TextField__LeftIcon",
  componentId: "lui__sc-1h9z42q-2"
})(["position:absolute;top:12px;left:12px;"]);
function TextFieldComponent(_ref, ref) {
  var {
      inputId,
      name,
      variant = 'text',
      value,
      defaultValue,
      onChange,
      validationState,
      label,
      ariaLabel,
      ariaLabelledBy,
      labelSuffix,
      inlineAction,
      autoComplete,
      placeholder,
      helpText,
      errorText,
      isDisabled,
      isRequired,
      maxCharCount,
      minCharCount,
      width = '100%',
      minWidth,
      maxWidth
    } = _ref,
    props = _objectWithoutProperties(_ref, TextField_a97ed0b9_esm_excluded);
  var globalProps = filterGlobalProps(props);
  var {
    isCleared,
    handleChange,
    clearValue
  } = TextField_a97ed0b9_esm_useClearAction(onChange, ref, value);
  var inputElId = isChromatic() ? '1' : inputId !== null && inputId !== void 0 ? inputId : cuid();
  var helpTextId = isChromatic() ? '2' : cuid();
  var errorTextId = isChromatic() ? '3' : cuid();
  var hasError = errorText && validationState === 'invalid';
  var theme = useTheme();
  var ariaDescribedBy = [];
  if (helpText) {
    ariaDescribedBy.push(helpTextId);
  }
  if (hasError) {
    ariaDescribedBy.push(errorTextId);
  }
  return /*#__PURE__*/jsxs(Spacer, _objectSpread2(_objectSpread2({
    ygap: "xxs",
    width: width,
    minWidth: minWidth,
    maxWidth: maxWidth
  }, globalProps), {}, {
    children: [label && /*#__PURE__*/jsx(TextField_a97ed0b9_esm_FieldLabel, {
      forId: inputElId,
      label: label,
      labelSuffix: labelSuffix
    }), /*#__PURE__*/jsxs(Spacer, {
      ygap: "xxs",
      children: [/*#__PURE__*/jsxs(TextField_a97ed0b9_esm_Wrapper, {
        children: [variant === 'email' && /*#__PURE__*/jsx(LeftIcon, {
          "aria-hidden": true,
          children: /*#__PURE__*/jsx(SvgEmail, {
            color: isDisabled ? theme.color.interaction.disabled : theme.color.text.subtle,
            width: "24px",
            height: "24px"
          })
        }), /*#__PURE__*/jsx(Input, {
          id: inputElId,
          name: name,
          type: variant,
          placeholder: placeholder,
          validationState: validationState,
          value: value && isCleared ? '' : value,
          defaultValue: defaultValue,
          onChange: handleChange,
          ref: ref,
          "aria-invalid": validationState === 'invalid',
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledBy,
          "aria-describedby": ariaDescribedBy.length > 0 ? ariaDescribedBy.join(' ') : undefined,
          autoComplete: variant === 'email' ? 'email' : autoComplete,
          required: isRequired,
          disabled: isDisabled,
          maxLength: maxCharCount,
          minLength: minCharCount,
          hasLeftItem: variant === 'email',
          hasRightItem: !!inlineAction
        }), inlineAction === 'clear' && /*#__PURE__*/jsx(TextField_a97ed0b9_esm_ClearActionButton, {
          isCleared: isCleared,
          clearValue: clearValue
        })]
      }), helpText && /*#__PURE__*/jsx(TextField_a97ed0b9_esm_HelpText, {
        id: helpTextId,
        text: helpText
      }), hasError && errorText && /*#__PURE__*/jsx(TextField_a97ed0b9_esm_ErrorText, {
        id: errorTextId,
        text: errorText
      })]
    })]
  }));
}
var TextField = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(TextFieldComponent)));



;// CONCATENATED MODULE: ../node_modules/@lendi/ui/dist/NumericField-32def1c6.esm.js











/**
 * Remove invalid characters
 */
var removeInvalidChars = function removeInvalidChars(value) {
  if (value) {
    var reg = new RegExp("[^\\d.]", 'gi');
    return value.replace(reg, '');
  }
  return '';
};

/**
 * Remove group separator from value eg. 1,000 > 1000
 */
var removeSeparators = function removeSeparators(value) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
  var reg = new RegExp(escapeRegExp(separator), 'g');
  return value.replace(reg, '');
};

var NumericField_32def1c6_esm_cleanNumericValue = _ref => {
  var {
    value,
    allowDecimal = false
  } = _ref;
  var groupSeparator = ',';
  var decimalSeparator = '.';
  var decimalsLimit = 2;
  var withoutSeparators = removeSeparators(value, groupSeparator);
  var withoutInvalidChars = removeInvalidChars(withoutSeparators);
  var valueOnly = withoutInvalidChars;

  // This is the part that takes care of trimming the decimals
  if (valueOnly.includes(decimalSeparator)) {
    var [int, decimals] = withoutInvalidChars.split(decimalSeparator);
    var trimmedDecimals = decimals ? decimals.slice(0, decimalsLimit) : decimals;
    var includeDecimals = allowDecimal ? "".concat(decimalSeparator).concat(trimmedDecimals) : '';
    return "".concat(int).concat(includeDecimals);
  }
  return valueOnly;
};

var NumericField_32def1c6_esm_excluded = (/* unused pure expression or super */ null && (["inputId", "name", "helpText", "errorText", "validationState", "placeholder", "ariaLabel", "ariaLabelledBy", "label", "labelSuffix", "inlineAction", "isRequired", "isDisabled", "value", "defaultValue", "onChange", "onValueChange", "width", "minWidth", "maxWidth", "maxCharCount", "minCharCount"]));
var NumericField_32def1c6_esm_Input = (0,styled_components_browser_esm/* default */.ZP)(InputBaseComponent).withConfig({
  displayName: "NumericField__Input",
  componentId: "lui__sc-1xofghe-0"
})(["padding-left:", ";padding-right:", ";"], _ref => {
  var {
    variant
  } = _ref;
  return variant && variant === 'dollar' ? (0,commons_esm/* pxToRem */.Q1)(46) : (0,commons_esm/* pxToRem */.Q1)(16);
}, _ref2 => {
  var {
    hasRightItem
  } = _ref2;
  return hasRightItem ? (0,commons_esm/* pxToRem */.Q1)(46) : (0,commons_esm/* pxToRem */.Q1)(16);
});
var NumericField_32def1c6_esm_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "NumericField__Wrapper",
  componentId: "lui__sc-1xofghe-1"
})(["position:relative;width:100%;"]);
function NumericFieldComponent(_ref3, ref) {
  var {
      inputId,
      name,
      helpText,
      errorText,
      validationState,
      placeholder,
      ariaLabel,
      ariaLabelledBy,
      label,
      labelSuffix,
      inlineAction,
      isRequired,
      isDisabled,
      value,
      defaultValue,
      onChange,
      onValueChange,
      width = '100%',
      minWidth,
      maxWidth,
      maxCharCount,
      minCharCount
    } = _ref3,
    props = _objectWithoutProperties(_ref3, NumericField_32def1c6_esm_excluded);
  var globalProps = filterGlobalProps(props);
  var inputElId = isChromatic() ? '1' : inputId !== null && inputId !== void 0 ? inputId : cuid();
  var helpTextId = isChromatic() ? '2' : cuid();
  var errorTextId = isChromatic() ? '3' : cuid();
  var hasError = errorText && validationState === 'invalid';
  var handleOnChange = event => {
    var valueOnly = NumericField_32def1c6_esm_cleanNumericValue({
      value: event.target.value
    });
    event.target.value = valueOnly;
    onChange === null || onChange === void 0 ? void 0 : onChange(event);
    if (valueOnly === '') {
      onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(undefined, name);
      return;
    }
    onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(Number(valueOnly), name);
  };
  var {
    isCleared,
    handleChange,
    clearValue
  } = useClearAction(handleOnChange, ref, value === null || value === void 0 ? void 0 : value.toString());
  var ariaDescribedBy = [];
  if (helpText) {
    ariaDescribedBy.push(helpTextId);
  }
  if (hasError) {
    ariaDescribedBy.push(errorTextId);
  }
  return /*#__PURE__*/jsxs(Spacer, _objectSpread2(_objectSpread2({
    ygap: "xxs",
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth
  }, globalProps), {}, {
    children: [label && /*#__PURE__*/jsx(FieldLabel, {
      forId: inputElId,
      label: label,
      labelSuffix: labelSuffix
    }), /*#__PURE__*/jsxs(Spacer, {
      ygap: "xxs",
      children: [/*#__PURE__*/jsxs(NumericField_32def1c6_esm_Wrapper, {
        children: [/*#__PURE__*/jsx(NumericField_32def1c6_esm_Input, {
          id: inputElId,
          name: name,
          type: "text",
          pattern: "[0-9]*",
          placeholder: placeholder,
          validationState: validationState,
          "aria-invalid": validationState === 'invalid',
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledBy,
          "aria-describedby": ariaDescribedBy.length > 0 ? ariaDescribedBy.join(' ') : undefined,
          required: isRequired,
          disabled: isDisabled,
          maxLength: maxCharCount,
          minLength: minCharCount,
          value: value && isCleared ? '' : value,
          defaultValue: defaultValue,
          onChange: handleChange,
          ref: ref,
          hasRightItem: !!inlineAction,
          inputMode: "numeric"
        }), inlineAction === 'clear' && /*#__PURE__*/jsx(ClearActionButton, {
          isCleared: isCleared,
          clearValue: clearValue
        })]
      }), helpText && /*#__PURE__*/jsx(HelpText, {
        id: helpTextId,
        text: helpText
      }), hasError && errorText && /*#__PURE__*/jsx(ErrorText, {
        id: errorTextId,
        text: errorText
      })]
    })]
  }));
}
var NumericField = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(NumericFieldComponent)));



// EXTERNAL MODULE: ../../../node_modules/leading-zeroes/dist/index.js
var dist = __webpack_require__(41699);
;// CONCATENATED MODULE: ../node_modules/@lendi/ui/dist/DateField-a31366ff.esm.js






















var DateField_a31366ff_esm_excluded = (/* unused pure expression or super */ null && (["inputId", "name", "variant", "helpText", "errorText", "validationState", "ariaLabel", "ariaLabelledBy", "label", "labelSuffix", "isRequired", "isDisabled", "defaultValue", "value", "onChange", "width", "minWidth", "maxWidth", "minDate", "maxDate"]));
var DateField_a31366ff_esm_Input = (0,styled_components_browser_esm/* default */.ZP)(InputBaseComponent).withConfig({
  displayName: "DateField__Input",
  componentId: "lui__sc-uzb5tf-0"
})(["--border-radius:", ";border-radius:0;&:first-of-type{border-radius:var(--border-radius) 0 0 var(--border-radius);}&:nth-of-type(2){border-left:none;}&:last-of-type{border-left:none;border-radius:0 var(--border-radius) var(--border-radius) 0;}&:focus-visible{box-shadow:none;}"], _ref => {
  var {
    theme
  } = _ref;
  return (0,borders_dist_commons_esm/* getBorderRadius */.wK)({
    theme: theme.name
  });
});
var DateField_a31366ff_esm_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(index_9102c435_esm_Spacer).withConfig({
  displayName: "DateField__Wrapper",
  componentId: "lui__sc-uzb5tf-1"
})(["position:relative;"]);
var DateFieldsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DateField__DateFieldsWrapper",
  componentId: "lui__sc-uzb5tf-2"
})(["display:flex;border-radius:", ";box-shadow:", ";&:hover{", "{border-color:", ";}}"], _ref2 => {
  var {
    theme
  } = _ref2;
  return (0,borders_dist_commons_esm/* getBorderRadius */.wK)({
    theme: theme.name
  });
}, props => props.isFocused && (0,borders_dist_commons_esm/* getFocusRing */.yb)(), DateField_a31366ff_esm_Input, _ref3 => {
  var {
    isDisabled,
    validationState,
    theme
  } = _ref3;
  if (isDisabled) {
    return theme.color.border.container;
  }
  if (validationState === 'invalid') {
    return theme.color.interaction.error;
  } else {
    return theme.color.border.interaction.hover;
  }
});

// Worth moving this when something else needs a fieldset/legend
// but for now its only one :)
var Fieldset = styled_components_browser_esm/* default.fieldset.withConfig */.ZP.fieldset.withConfig({
  displayName: "DateField__Fieldset",
  componentId: "lui__sc-uzb5tf-3"
})(["margin:0;padding:0;border:none;legend{margin-bottom:", ";}"], (0,commons_esm/* pxToRem */.Q1)(8));
var filterAlphabet = value => value.replace(/\D*/g, '');
function DateFieldComponent(_ref4, ref) {
  var {
      inputId,
      name,
      variant = 'daymonthyear',
      helpText,
      errorText,
      validationState,
      ariaLabel,
      ariaLabelledBy,
      label,
      labelSuffix,
      isRequired,
      isDisabled,
      defaultValue,
      value,
      onChange,
      width = '100%',
      minWidth,
      maxWidth,
      minDate,
      maxDate
    } = _ref4,
    props = _objectWithoutProperties(_ref4, DateField_a31366ff_esm_excluded);
  var globalProps = filterGlobalProps(props);
  var [isFocused, setIsFocused] = useState(false);
  var [day, setDay] = useState('');
  var [month, setMonth] = useState('');
  var [year, setYear] = useState('');
  var [fullDate, setFullDate] = useState('');
  var inputElId = isChromatic() ? '1' : inputId !== null && inputId !== void 0 ? inputId : cuid();
  var helpTextId = isChromatic() ? '2' : cuid();
  var errorTextId = isChromatic() ? '3' : cuid();
  var hasError = errorText && validationState === 'invalid';
  var hasFullDate = fullDate.length > 0;
  var inputRef = ref;
  var yearRef = useRef(null);
  var getRealMonth = dateObject => getMonth(dateObject) + 1;
  var applyDateToState = date => {
    var dateObject = toDate(date);
    if (dateIsValid(dateObject)) {
      setDay(leadingZeroes(getDate(dateObject).toString(), 2));
      setMonth(leadingZeroes(getRealMonth(dateObject).toString(), 2));
      setYear(getYear(dateObject).toString());
    }
  };
  // Used only to initialise the fields with default values
  useEffect(() => {
    var defaultDate = value !== null && value !== void 0 ? value : defaultValue;
    if (defaultDate) {
      applyDateToState(defaultDate);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Manage when to update the full date
  useEffect(() => {
    if (day && month && year) {
      setFullDate("".concat(year, "-").concat(month, "-").concat(day));
    }
  }, [day, month, year]);

  // Manage reporting the full date string & other details back to the consumer:
  // This effectively is a fake onChange handler in place of the lack of a real onChange given the management of 3 different input fields.
  useEffect(() => {
    if (onChange && hasFullDate) {
      // Because I'm doing this outside of a real change event, I have created a fakeEvent to send back to consumer
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      var fakeEvent = {
        target: {
          value: fullDate,
          validity: getValidity(fullDate)
        }
        // using `as` here to bypass typescript's requirements to add missing values in the real event object
      };

      onChange(fakeEvent);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasFullDate, fullDate]);
  var getValidity = fullDate => {
    var validity = {
      patternMismatch: false,
      rangeOverflow: false,
      rangeUnderflow: false
    };
    if (day.length !== 2 && month.length !== 2 && year.length !== 4) {
      validity.patternMismatch = true;
      return validity;
    }
    var dateInput = toDate(new Date(fullDate));

    // dateIsValid handles dates which exceed days in a month etc.
    if (dateIsValid(dateInput)) {
      var minDateObject = minDate && toDate(minDate);
      var maxDateObject = maxDate && toDate(maxDate);
      var dateIsBeforeIsBeforeMinDate = minDateObject && isBefore(dateInput, minDateObject);
      var dateIsAfterMaxDate = maxDateObject && isAfter(dateInput, maxDateObject);
      if (dateIsBeforeIsBeforeMinDate) {
        validity.rangeUnderflow = true;
        inputRef === null || inputRef === void 0 ? void 0 : inputRef.current.setCustomValidity('You have entered a date before the accepted minimum date');
      }
      if (dateIsAfterMaxDate) {
        validity.rangeOverflow = true;
        inputRef === null || inputRef === void 0 ? void 0 : inputRef.current.setCustomValidity('You have exceeded the number of days in this month');
      }
    } else {
      validity.patternMismatch = true;
    }
    return validity;
  };
  var handleChange = type => e => {
    // Ensures there's no alphabet in the inputs
    if (e.target.value !== '') {
      e.target.value = filterAlphabet(e.target.value);
    }
    if (type === 'day') setDay(e.target.value);
    if (type === 'month') setMonth(e.target.value);
    if (type === 'year') setYear(e.target.value);
  };
  var handleOnPaste = e => {
    e.clipboardData.items[0].getAsString(text => {
      // Only really supporting the Queen's date format here
      var parsedDate = text && dateParse(text, 'dd/MM/yyyy', new Date());
      if (parsedDate && dateIsValid(parsedDate)) {
        var _yearRef$current;
        applyDateToState(parsedDate);
        // Once we apply the date to the state, we shift the user to the year input
        // to create the affect of having entered the date manually, and to provide
        // a better flow
        yearRef === null || yearRef === void 0 ? void 0 : (_yearRef$current = yearRef.current) === null || _yearRef$current === void 0 ? void 0 : _yearRef$current.focus();
      }
    });
  };
  var onFocusHandler = () => !isFocused && setIsFocused(true);
  var onBlurHandler = () => isFocused && setIsFocused(false);
  var showDayField = variant === 'daymonthyear';
  var showMonthField = variant === 'daymonthyear' || variant === 'monthyear';
  var showYearField = variant === 'daymonthyear' || variant === 'monthyear';
  return /*#__PURE__*/jsx(Spacer, _objectSpread2(_objectSpread2({
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth
  }, globalProps), {}, {
    children: /*#__PURE__*/jsxs(Fieldset, {
      disabled: isDisabled,
      children: [label && /*#__PURE__*/jsxs("legend", {
        children: [/*#__PURE__*/jsx(FieldLabel, {
          forId: "",
          tag: "span",
          label: label,
          labelSuffix: labelSuffix
        }), helpText && /*#__PURE__*/jsx("span", {
          className: "sr-only",
          children: helpText
        }), hasError && errorText && /*#__PURE__*/jsx("span", {
          className: "sr-only",
          children: errorText
        })]
      }), /*#__PURE__*/jsxs(DateField_a31366ff_esm_Wrapper, {
        ygap: "xxs",
        children: [/*#__PURE__*/jsx("input", {
          type: "text",
          value: fullDate,
          ref: inputRef,
          "aria-disabled": true,
          "aria-hidden": true,
          hidden: true,
          disabled: true,
          readOnly: true
        }), /*#__PURE__*/jsxs(DateFieldsWrapper, {
          isFocused: isFocused,
          isDisabled: isDisabled,
          validationState: validationState,
          children: [showDayField && /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx(VisuallyHidden, {
              children: /*#__PURE__*/jsx(FieldLabel, {
                forId: "".concat(inputElId, "-day"),
                label: "Day"
              })
            }), /*#__PURE__*/jsx(DateField_a31366ff_esm_Input, {
              id: "".concat(inputElId, "-day"),
              placeholder: "DD",
              inputMode: "numeric",
              pattern: "[0-9]{2}",
              minLength: 2,
              maxLength: 2,
              validationState: validationState,
              value: day,
              required: isRequired,
              onChange: handleChange('day'),
              onFocus: onFocusHandler,
              onBlur: onBlurHandler,
              onPaste: handleOnPaste,
              autoComplete: "bday-day"
            })]
          }), showMonthField && /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx(VisuallyHidden, {
              children: /*#__PURE__*/jsx(FieldLabel, {
                forId: "".concat(inputElId, "-month"),
                label: "Month"
              })
            }), /*#__PURE__*/jsx(DateField_a31366ff_esm_Input, {
              id: "".concat(inputElId, "-month"),
              placeholder: "MM",
              inputMode: "numeric",
              pattern: "[0-9]{2}",
              minLength: 2,
              maxLength: 2,
              validationState: validationState,
              value: month,
              required: isRequired,
              onChange: handleChange('month'),
              onFocus: onFocusHandler,
              onBlur: onBlurHandler,
              onPaste: handleOnPaste,
              autoComplete: "bday-month"
            })]
          }), showYearField && /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx(VisuallyHidden, {
              children: /*#__PURE__*/jsx(FieldLabel, {
                forId: "".concat(inputElId, "-year"),
                label: "Year"
              })
            }), /*#__PURE__*/jsx(DateField_a31366ff_esm_Input, {
              id: "".concat(inputElId, "-year"),
              placeholder: "YYYY",
              inputMode: "numeric",
              pattern: "[0-9]{4}",
              minLength: 4,
              maxLength: 4,
              validationState: validationState,
              value: year,
              required: isRequired,
              onChange: handleChange('year'),
              onFocus: onFocusHandler,
              onBlur: onBlurHandler,
              onPaste: handleOnPaste,
              autoComplete: "bday-year",
              ref: yearRef
            })]
          })]
        }), helpText && /*#__PURE__*/jsx("div", {
          "aria-hidden": "true",
          children: /*#__PURE__*/jsx(HelpText, {
            id: helpTextId,
            text: helpText
          })
        }), hasError && errorText && /*#__PURE__*/jsx("div", {
          "aria-hidden": "true",
          children: /*#__PURE__*/jsx(ErrorText, {
            id: errorTextId,
            text: errorText
          })
        })]
      })]
    })
  }));
}
var DateField = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(DateFieldComponent)));



;// CONCATENATED MODULE: ../node_modules/@lendi/ui/dist/helpers-84f3bf7a.esm.js


















/**
 * This is a 100% duplicate of `@lendi-ui/icon/Call`.
 *
 * It is used in LUI Next PhoneField
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
function SvgAttachMoney(props) {
  return /*#__PURE__*/jsx(IconWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/jsx("path", {
        d: "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"
      }), /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })]
    })
  }));
}

var formatToCurrency = _value => {
  var _value$match;
  var decimalSeparator = '.';
  if (_value === '' || _value === undefined) {
    return '';
  }
  var value = _value;

  // This is somewhat of an overkill way to do currency formatting,
  // but it covers some interesting edge cases like if there's a decimal number (123.10)
  // and you delete the 123, it will magically replace it with a 0 to ensure proper format (0.10)
  var numberFormatter = new Intl.NumberFormat('en-AU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 20
  });
  var formatted = numberFormatter.format(Number(value));

  // Include decimal separator if user input ends with decimal separator
  var includeDecimalSeparator = _value.slice(-1) === decimalSeparator ? decimalSeparator : '';
  var [, decimals] = (_value$match = value.match(RegExp('\\d+\\.(\\d+)'))) !== null && _value$match !== void 0 ? _value$match : [];

  // Keep original decimal padding if no decimalScale
  if (decimals && decimalSeparator) {
    if (formatted.includes(decimalSeparator)) {
      formatted = formatted.replace(RegExp("(\\d+)(".concat(escapeRegExp(decimalSeparator), ")(\\d+)"), 'g'), "$1$2".concat(decimals));
    } else {
      formatted = "".concat(formatted).concat(decimalSeparator).concat(decimals);
    }
  }
  return [formatted, includeDecimalSeparator].join('');
};

var padTrimValue = function padTrimValue(value) {
  var decimalSeparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.';
  var decimalScale = 2;
  if (value === '' || value === undefined || !value.includes(decimalSeparator)) {
    return value;
  }
  if (!value.match(/\d/g)) {
    return '';
  }
  var [int, decimals] = value.split(decimalSeparator);
  var newValue = decimals || '';
  if (newValue.length < decimalScale) {
    while (newValue.length < decimalScale) {
      newValue += '0';
    }
  } else {
    newValue = newValue.slice(0, decimalScale);
  }
  return "".concat(int).concat(decimalSeparator).concat(newValue);
};

var helpers_84f3bf7a_esm_excluded = (/* unused pure expression or super */ null && (["inputId", "name", "helpText", "errorText", "validationState", "placeholder", "ariaLabel", "ariaLabelledBy", "label", "labelSuffix", "inlineAction", "isRequired", "isDisabled", "value", "defaultValue", "onChange", "onValueChange", "onBlur", "width", "minWidth", "maxWidth", "maxCharCount", "minCharCount"]));
var helpers_84f3bf7a_esm_Input = (0,styled_components_browser_esm/* default */.ZP)(InputBaseComponent).withConfig({
  displayName: "DollarField__Input",
  componentId: "lui__sc-1g3sog3-0"
})(["padding-left:", ";padding-right:", ";"], (0,commons_esm/* pxToRem */.Q1)(46), _ref => {
  var {
    hasRightItem
  } = _ref;
  return hasRightItem ? (0,commons_esm/* pxToRem */.Q1)(46) : (0,commons_esm/* pxToRem */.Q1)(16);
});
var helpers_84f3bf7a_esm_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DollarField__Wrapper",
  componentId: "lui__sc-1g3sog3-1"
})(["position:relative;width:100%;"]);
var LeftInputFieldIconWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "DollarField__LeftInputFieldIconWrapper",
  componentId: "lui__sc-1g3sog3-2"
})(["position:absolute;top:12px;left:12px;"]);
function DollarFieldComponent(_ref2, ref) {
  var {
      inputId,
      name,
      helpText,
      errorText,
      validationState,
      placeholder,
      ariaLabel,
      ariaLabelledBy,
      label,
      labelSuffix,
      inlineAction,
      isRequired,
      isDisabled,
      value: userValue,
      defaultValue,
      onChange,
      onValueChange,
      onBlur,
      width = '100%',
      minWidth,
      maxWidth,
      maxCharCount,
      minCharCount
    } = _ref2,
    props = _objectWithoutProperties(_ref2, helpers_84f3bf7a_esm_excluded);
  var globalProps = filterGlobalProps(props);
  var inputElId = isChromatic() ? '1' : inputId !== null && inputId !== void 0 ? inputId : cuid();
  var helpTextId = isChromatic() ? '2' : cuid();
  var errorTextId = isChromatic() ? '3' : cuid();
  var hasError = errorText && validationState === 'invalid';
  var theme = useTheme();

  // This is of course against hook rules, but in order for cursor tracking to work,
  // we must always have a valid ref to the input available
  // eslint-disable-next-line react-hooks/rules-of-hooks
  var inputRef = ref !== null && ref !== void 0 ? ref : useRef(null);
  var initialStateValue = defaultValue !== undefined ? formatToCurrency(String(defaultValue)) : userValue !== undefined ? formatToCurrency(String(userValue)) : '';
  var [stateValue, setStateValue] = useState(initialStateValue);
  var [dirty, setDirty] = useState(false);
  var [cursor, setCursor] = useState(0);
  var processValue = (value, selectionStart, name) => {
    setDirty(true);
    var valueOnly = cleanNumericValue({
      value,
      allowDecimal: true
    });
    if (valueOnly === '') {
      onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(undefined, name);
      setStateValue('');
      return;
    }
    if (maxCharCount && valueOnly.length > maxCharCount) {
      return;
    }
    if (valueOnly === '.') {
      onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(undefined, name);
      setStateValue(valueOnly);
      return;
    }
    var formatted = formatToCurrency(valueOnly);
    if (selectionStart !== undefined && selectionStart !== null) {
      // Prevent cursor jumping
      var newCursor = selectionStart + (formatted.length - value.length) || 0;
      var isNegative = Math.sign(newCursor) < 0;
      setCursor(isNegative ? 0 : newCursor);
    }
    setStateValue(formatted);
    onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(valueOnly, name);
  };
  var handleOnChange = event => {
    event.persist();
    var {
      target: {
        value,
        selectionStart
      }
    } = event;
    processValue(value, selectionStart);
    onChange === null || onChange === void 0 ? void 0 : onChange(event);
  };
  var handleOnKeyUp = event => {
    var {
      key,
      currentTarget: {
        selectionStart
      }
    } = event;
    if (key !== 'ArrowUp' && key !== 'ArrowDown') {
      if (selectionStart && selectionStart > stateValue.length) {
        if (inputRef && typeof inputRef === 'object' && inputRef.current) {
          var newCursor = stateValue.length;
          inputRef.current.setSelectionRange(newCursor, newCursor);
        }
      }
    }
  };
  var handleOnFocus = event => {
    return stateValue ? stateValue.length : 0;
  };
  var handleOnBlur = event => {
    event.persist();
    var {
      target: {
        value
      }
    } = event;
    if (value) {
      var valueOnly = cleanNumericValue({
        value,
        allowDecimal: true
      });
      if (!valueOnly) {
        setStateValue('');
        return;
      }
      var paddedDecimalsValue = padTrimValue(valueOnly);
      onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(paddedDecimalsValue, name);
      var formattedValue = formatToCurrency(paddedDecimalsValue);
      setStateValue(formattedValue);
    }
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
  };
  useEffect(() => {
    // prevent cursor jumping if editing value
    if (dirty && inputRef && typeof inputRef === 'object' && inputRef.current) {
      inputRef.current.setSelectionRange(cursor, cursor);
    }
  }, [stateValue, cursor, inputRef, dirty]);
  var formattedPropsValue = userValue !== undefined ? formatToCurrency(String(userValue)) : undefined;
  var inputValue = formattedPropsValue !== undefined && stateValue !== '.' ? formattedPropsValue : stateValue;
  var {
    isCleared,
    handleChange,
    clearValue
  } = useClearAction(handleOnChange, inputRef, inputValue);
  var ariaDescribedBy = [];
  if (helpText) {
    ariaDescribedBy.push(helpTextId);
  }
  if (hasError) {
    ariaDescribedBy.push(errorTextId);
  }
  return /*#__PURE__*/jsxs(Spacer, _objectSpread2(_objectSpread2({
    ygap: "xxs",
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth
  }, globalProps), {}, {
    children: [label && /*#__PURE__*/jsx(FieldLabel, {
      forId: inputElId,
      label: label,
      labelSuffix: labelSuffix
    }), /*#__PURE__*/jsxs(Spacer, {
      ygap: validationState === 'invalid' ? 'xxs' : 'xs',
      children: [/*#__PURE__*/jsxs(helpers_84f3bf7a_esm_Wrapper, {
        children: [/*#__PURE__*/jsx(LeftInputFieldIconWrapper, {
          "aria-hidden": true,
          children: /*#__PURE__*/jsx(SvgAttachMoney, {
            color: isDisabled ? theme.color.interaction.disabled : theme.color.text.subtle,
            width: "24px",
            height: "24px"
          })
        }), /*#__PURE__*/jsx(helpers_84f3bf7a_esm_Input, {
          id: inputElId,
          name: name,
          type: "text",
          pattern: "[0-9,.]*",
          placeholder: placeholder,
          validationState: validationState,
          "aria-invalid": validationState === 'invalid',
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledBy,
          "aria-describedby": ariaDescribedBy.length > 0 ? ariaDescribedBy.join(' ') : undefined,
          required: isRequired,
          disabled: isDisabled,
          maxLength: maxCharCount,
          minLength: minCharCount,
          onBlur: handleOnBlur,
          onKeyUp: handleOnKeyUp,
          onFocus: handleOnFocus,
          value: inputValue && isCleared ? '' : inputValue,
          onChange: handleChange,
          hasRightItem: !!inlineAction,
          inputMode: "decimal",
          ref: inputRef
        }), inlineAction === 'clear' && /*#__PURE__*/jsx(ClearActionButton, {
          isCleared: isCleared,
          clearValue: clearValue
        })]
      }), helpText && /*#__PURE__*/jsx(HelpText, {
        id: helpTextId,
        text: helpText
      }), hasError && errorText && /*#__PURE__*/jsx(ErrorText, {
        id: errorTextId,
        text: errorText
      })]
    })]
  }));
}
var DollarField = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(DollarFieldComponent)));

var dollarToNumber = dollar => parseFloat(dollar === null || dollar === void 0 ? void 0 : dollar.replace(',', ''));



;// CONCATENATED MODULE: ../node_modules/@lendi/ui/dist/PhoneField-b3c54f49.esm.js


















/**
 * This is a 100% duplicate of `@lendi-ui/icon/Call`.
 *
 * It is used in LUI Next PhoneField
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
function SvgCall(props) {
  return /*#__PURE__*/jsx(IconWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), /*#__PURE__*/jsx("path", {
        d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
      })]
    })
  }));
}

/**
 * This is a 100% duplicate of `@lendi-ui/icon/PhoneAndroid`.
 *
 * It is used in LUI Next PhoneField
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
function SvgPhoneAndroid(props) {
  return /*#__PURE__*/jsx(IconWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/jsx("path", {
        d: "M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm-2 20h-4v-1h4v1zm3.25-3H6.75V4h10.5v14z"
      }), /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })]
    })
  }));
}

var PhoneField_b3c54f49_esm_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PhoneFieldstyle__Wrapper",
  componentId: "lui__sc-c2e1lq-0"
})(["position:relative;width:100%;"]);
var PhoneField_b3c54f49_esm_Input = (0,styled_components_browser_esm/* default */.ZP)(InputBaseComponent).withConfig({
  displayName: "PhoneFieldstyle__Input",
  componentId: "lui__sc-c2e1lq-1"
})(["padding-left:", ";padding-right:", ";"], (0,commons_esm/* pxToRem */.Q1)(46), _ref => {
  var {
    hasRightItem
  } = _ref;
  return hasRightItem ? (0,commons_esm/* pxToRem */.Q1)(46) : (0,commons_esm/* pxToRem */.Q1)(16);
});
var PhoneIconWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "PhoneFieldstyle__PhoneIconWrapper",
  componentId: "lui__sc-c2e1lq-2"
})(["position:absolute;top:", ";left:", ";"], (0,commons_esm/* pxToRem */.Q1)(12), (0,commons_esm/* pxToRem */.Q1)(12));
var MobileIconWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "PhoneFieldstyle__MobileIconWrapper",
  componentId: "lui__sc-c2e1lq-3"
})(["position:absolute;top:", ";left:", ";"], (0,commons_esm/* pxToRem */.Q1)(12), (0,commons_esm/* pxToRem */.Q1)(12));

var getPattern = variant => {
  switch (variant) {
    case 'mobile':
      return "^04{1}[0-9]{2}[0-9]{3}[0-9]{3}$";
    default:
      return "^0{1}[2378]{1}[0-9]{4}[0-9]{4}$";
  }
};

var PhoneField_b3c54f49_esm_excluded = (/* unused pure expression or super */ null && (["inputId", "name", "variant", "helpText", "errorText", "validationState", "placeholder", "ariaLabel", "ariaLabelledBy", "label", "labelSuffix", "inlineAction", "isRequired", "isDisabled", "value", "defaultValue", "onChange", "width", "maxCharCount", "minCharCount", "minWidth", "maxWidth"]));
var PhoneField_b3c54f49_esm_filterAlphabet = value => value.replace(/\D*/g, '');
var handleFormatting = value => {
  // because we handle uncontrolled, this function could receive undefined.
  if (value) {
    return PhoneField_b3c54f49_esm_filterAlphabet(value);
  }
  return value;
};
var PhoneFieldComponent = (_ref, ref) => {
  var {
      inputId,
      name,
      variant,
      helpText,
      errorText,
      validationState,
      placeholder,
      ariaLabel,
      ariaLabelledBy,
      label,
      labelSuffix,
      inlineAction,
      isRequired,
      isDisabled,
      value,
      defaultValue,
      onChange,
      width = '100%',
      maxCharCount,
      minCharCount,
      minWidth,
      maxWidth
    } = _ref,
    props = _objectWithoutProperties(_ref, PhoneField_b3c54f49_esm_excluded);
  var globalProps = filterGlobalProps(props);
  var inputElId = isChromatic() ? '1' : inputId !== null && inputId !== void 0 ? inputId : cuid();
  var helpTextId = isChromatic() ? '2' : cuid();
  var errorTextId = isChromatic() ? '3' : cuid();
  var hasError = errorText && validationState === 'invalid';
  var theme = useTheme();
  var handleValueChange = e => {
    if (e.target.value !== '') {
      var _handleFormatting;
      e.target.value = (_handleFormatting = handleFormatting(e.target.value)) !== null && _handleFormatting !== void 0 ? _handleFormatting : '';
    }
    if (onChange) {
      onChange(e);
    }
  };
  var {
    isCleared,
    handleChange,
    clearValue
  } = useClearAction(handleValueChange, ref, value);
  var ariaDescribedBy = [];
  if (helpText) {
    ariaDescribedBy.push(helpTextId);
  }
  if (hasError) {
    ariaDescribedBy.push(errorTextId);
  }
  return /*#__PURE__*/jsxs(Spacer, _objectSpread2(_objectSpread2({
    ygap: "xxs",
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth
  }, globalProps), {}, {
    children: [label && /*#__PURE__*/jsx(FieldLabel, {
      forId: inputElId,
      label: label,
      labelSuffix: labelSuffix
    }), /*#__PURE__*/jsxs(Spacer, {
      ygap: "xxs",
      children: [/*#__PURE__*/jsxs(PhoneField_b3c54f49_esm_Wrapper, {
        children: [variant === 'mobile' ? /*#__PURE__*/jsx(MobileIconWrapper, {
          "aria-hidden": true,
          children: /*#__PURE__*/jsx(SvgPhoneAndroid, {
            color: isDisabled ? theme.color.interaction.disabled : theme.color.text.subtle,
            width: "24px",
            height: "24px"
          })
        }) : /*#__PURE__*/jsx(PhoneIconWrapper, {
          "aria-hidden": true,
          children: /*#__PURE__*/jsx(SvgCall, {
            color: isDisabled ? theme.color.interaction.disabled : theme.color.text.subtle,
            width: "24px",
            height: "24px"
          })
        }), /*#__PURE__*/jsx(PhoneField_b3c54f49_esm_Input, {
          id: inputElId,
          name: name,
          type: "tel",
          autoComplete: "tel",
          inputMode: "tel",
          pattern: getPattern(variant),
          placeholder: placeholder,
          validationState: validationState,
          "aria-invalid": validationState === 'invalid',
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledBy,
          "aria-describedby": ariaDescribedBy.length > 0 ? ariaDescribedBy.join(' ') : undefined,
          required: isRequired,
          disabled: isDisabled,
          maxLength: maxCharCount,
          minLength: minCharCount,
          value: value && isCleared ? '' : handleFormatting(value),
          defaultValue: handleFormatting(defaultValue),
          onChange: handleChange,
          ref: ref,
          hasRightItem: !!inlineAction,
          variant: variant
        }), inlineAction === 'clear' && /*#__PURE__*/jsx(ClearActionButton, {
          isCleared: isCleared,
          clearValue: clearValue
        })]
      }), helpText && /*#__PURE__*/jsx(HelpText, {
        id: helpTextId,
        text: helpText
      }), hasError && errorText && /*#__PURE__*/jsx(ErrorText, {
        id: errorTextId,
        text: errorText
      })]
    })]
  }));
};
var PhoneField = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(PhoneFieldComponent)));



;// CONCATENATED MODULE: ../node_modules/@lendi/ui/dist/UnitField-eb5b49bd.esm.js














var UnitField_eb5b49bd_esm_excluded = (/* unused pure expression or super */ null && (["inputId", "name", "variant", "helpText", "errorText", "validationState", "placeholder", "ariaLabel", "ariaLabelledBy", "label", "labelSuffix", "isRequired", "isDisabled", "value", "defaultValue", "onChange", "onValueChange", "width", "minWidth", "maxWidth", "maxCharCount", "minCharCount"]));
var getPaddingRight = variant => {
  switch (variant) {
    case 'age':
      return 98;
    case 'years':
      return 70;
    case 'months':
      return 86;
    case 'days':
      return 62;
    case 'percent':
      return 42;
  }
};
var UnitField_eb5b49bd_esm_Input = (0,styled_components_browser_esm/* default */.ZP)(InputBaseComponent).withConfig({
  displayName: "UnitField__Input",
  componentId: "lui__sc-1ywqqq4-0"
})(["padding-right:", ";"], props => "".concat(getPaddingRight(props.variant), "px"));
var UnitLabelWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "UnitField__UnitLabelWrapper",
  componentId: "lui__sc-1ywqqq4-1"
})(["position:absolute;right:1rem;top:50%;transform:translateY(-50%);"]);
var UnitField_eb5b49bd_esm_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "UnitField__Wrapper",
  componentId: "lui__sc-1ywqqq4-2"
})(["position:relative;width:100%;"]);
var getVariantLabel = variant => {
  switch (variant) {
    case 'age':
      return 'years old';
    case 'percent':
      return '%';
    default:
      return variant;
  }
};
var UnitLabel = _ref => {
  var {
    variant
  } = _ref;
  return /*#__PURE__*/jsx(UnitLabelWrapper, {
    "aria-hidden": "true",
    children: /*#__PURE__*/jsx(Text, {
      variant: "subtitle1",
      tag: "span",
      appearance: "subtle",
      children: getVariantLabel(variant)
    })
  });
};
function UnitFieldComponent(_ref2, ref) {
  var {
      inputId,
      name,
      variant,
      helpText,
      errorText,
      validationState,
      placeholder,
      ariaLabel,
      ariaLabelledBy,
      label: _label,
      labelSuffix,
      isRequired,
      isDisabled,
      value,
      defaultValue,
      onChange,
      onValueChange,
      width = '100%',
      minWidth,
      maxWidth,
      maxCharCount,
      minCharCount
    } = _ref2,
    props = _objectWithoutProperties(_ref2, UnitField_eb5b49bd_esm_excluded);
  var globalProps = filterGlobalProps(props);
  var inputElId = isChromatic() ? '1' : inputId !== null && inputId !== void 0 ? inputId : cuid();
  var helpTextId = isChromatic() ? '2' : cuid();
  var errorTextId = isChromatic() ? '3' : cuid();
  var hasError = errorText && validationState === 'invalid';
  var ariaDescribedBy = [];
  if (helpText) {
    ariaDescribedBy.push(helpTextId);
  }
  if (hasError) {
    ariaDescribedBy.push(errorTextId);
  }
  var handleOnChange = event => {
    var valueOnly = cleanNumericValue({
      value: event.target.value,
      allowDecimal: variant === 'percent'
    });
    var [, hasDecimals] = valueOnly.split('.');
    event.target.value = valueOnly;
    onChange === null || onChange === void 0 ? void 0 : onChange(event);
    if (valueOnly === '') {
      onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(undefined, name);
      return;
    }
    if (valueOnly === '.') {
      onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(undefined, name);
      return;
    }
    if (hasDecimals) {
      onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(parseFloat(valueOnly), name);
      return;
    }
    onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(Number(valueOnly), name);
  };
  return /*#__PURE__*/jsxs(Spacer, _objectSpread2(_objectSpread2({
    ygap: "xxs",
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth
  }, globalProps), {}, {
    children: [_label && /*#__PURE__*/jsx(FieldLabel, {
      forId: inputElId,
      label: () => /*#__PURE__*/jsxs(Fragment, {
        children: [_label, /*#__PURE__*/jsx(VisuallyHidden, {
          children: "(".concat(getVariantLabel(variant), ")")
        })]
      }),
      labelSuffix: labelSuffix
    }), /*#__PURE__*/jsxs(Spacer, {
      ygap: "xxs",
      children: [/*#__PURE__*/jsxs(UnitField_eb5b49bd_esm_Wrapper, {
        children: [/*#__PURE__*/jsx(UnitField_eb5b49bd_esm_Input, {
          id: inputElId,
          name: name,
          type: "text",
          pattern: variant === 'percent' ? '[0-9.]*' : '[0-9]*',
          placeholder: placeholder,
          validationState: validationState,
          "aria-invalid": validationState === 'invalid',
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledBy,
          "aria-describedby": ariaDescribedBy.length > 0 ? ariaDescribedBy.join(' ') : undefined,
          required: isRequired,
          disabled: isDisabled,
          maxLength: maxCharCount,
          minLength: minCharCount,
          value: value,
          defaultValue: defaultValue,
          onChange: handleOnChange,
          ref: ref,
          inputMode: variant === 'percent' ? 'decimal' : 'numeric',
          variant: variant
        }), /*#__PURE__*/jsx(UnitLabel, {
          variant: variant
        })]
      }), helpText && /*#__PURE__*/jsx(HelpText, {
        id: helpTextId,
        text: helpText
      }), hasError && errorText && /*#__PURE__*/jsx(ErrorText, {
        id: errorTextId,
        text: errorText
      })]
    })]
  }));
}
var UnitField = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(UnitFieldComponent)));



;// CONCATENATED MODULE: ../node_modules/@lendi/ui/dist/SelectField-77d1dc65.esm.js

















/**
 * This is a 100% duplicate of `@lendi-ui/icon/KeyboardArrowDown`.
 *
 * It is used in LUI Next SelectField
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
function SvgKeyboardArrowDown(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_style_741fda20_esm_IconWrapper, (0,index_03130070_esm._)((0,index_03130070_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0-.75h24v24H0z",
        fill: "none"
      })]
    })
  }));
}

var SelectField_77d1dc65_esm_excluded = (/* unused pure expression or super */ null && (["name", "inputId", "validationState", "helpText", "errorText", "placeholder", "label", "ariaLabel", "ariaLabelledBy", "labelSuffix", "isRequired", "isDisabled", "width", "minWidth", "maxWidth", "options", "onChange", "defaultValue", "value"]));
// TODO: if placeholder is active, color should be 600
// prettier-ignore
var Select = (0,styled_components_browser_esm/* default */.ZP)(InputBaseComponent).attrs({
  as: 'select'
}).withConfig({
  displayName: "SelectField__Select",
  componentId: "lui__sc-bl1fdz-0"
})(["appearance:none;display:flex;align-items:center;padding-top:0;padding-bottom:0;padding-right:40px;color:", ";&:disabled{color:", ";}"], _ref => {
  var {
    theme
  } = _ref;
  return theme.color.text.main;
}, _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.color.text.subtle;
});
var Arrow = (0,styled_components_browser_esm/* default */.ZP)(SvgKeyboardArrowDown).withConfig({
  displayName: "SelectField__Arrow",
  componentId: "lui__sc-bl1fdz-1"
})(["position:absolute;right:0.75em;top:50%;margin-top:calc(-0.75em + 1px);width:1.5em;height:1.5em;pointer-events:none;"]);
var SelectField_77d1dc65_esm_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectField__Wrapper",
  componentId: "lui__sc-bl1fdz-2"
})(["position:relative;width:100%;"]);
function SelectFieldComponent(_ref3, ref) {
  var {
      name,
      inputId,
      validationState,
      helpText,
      errorText,
      placeholder,
      label,
      ariaLabel,
      ariaLabelledBy,
      labelSuffix,
      isRequired,
      isDisabled,
      width = '100%',
      minWidth,
      maxWidth,
      options,
      onChange,
      defaultValue,
      value
    } = _ref3,
    props = _objectWithoutProperties(_ref3, SelectField_77d1dc65_esm_excluded);
  var globalProps = filterGlobalProps(props);
  var selectElId = isChromatic() ? '1' : inputId !== null && inputId !== void 0 ? inputId : cuid();
  var helpTextId = isChromatic() ? '2' : cuid();
  var errorTextId = isChromatic() ? '3' : cuid();
  var hasError = errorText && validationState === 'invalid';
  var hasNoValue = defaultValue === undefined && value === undefined;
  var theme = useTheme();
  var ariaDescribedBy = [];
  if (helpText) {
    ariaDescribedBy.push(helpTextId);
  }
  if (hasError) {
    ariaDescribedBy.push(errorTextId);
  }
  return /*#__PURE__*/jsxs(Spacer, _objectSpread2(_objectSpread2({
    ygap: "xxs",
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth
  }, globalProps), {}, {
    children: [label && /*#__PURE__*/jsx(FieldLabel, {
      forId: selectElId,
      label: label,
      labelSuffix: labelSuffix
    }), /*#__PURE__*/jsxs(Spacer, {
      ygap: "xxs",
      children: [/*#__PURE__*/jsxs(SelectField_77d1dc65_esm_Wrapper, {
        children: [/*#__PURE__*/jsxs(Select, {
          name: name,
          id: selectElId,
          validationState: validationState,
          "aria-invalid": validationState === 'invalid',
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledBy,
          "aria-describedby": ariaDescribedBy.length > 0 ? ariaDescribedBy.join(' ') : undefined,
          required: isRequired,
          disabled: isDisabled,
          onChange: onChange,
          value: onChange && hasNoValue && placeholder ? '' : value,
          defaultValue: !onChange && hasNoValue && placeholder ? '' : defaultValue,
          ref: ref,
          placeholder: placeholder,
          children: [placeholder && /*#__PURE__*/jsx("option", {
            value: "",
            disabled: true,
            hidden: true,
            children: placeholder
          }), options.length > 0 && options.map(option => {
            if ('value' in option) {
              if (option.value === '') {
                throw new Error('value cannot be an empty string');
              }
              return /*#__PURE__*/jsx("option", {
                value: option.value,
                children: option.label
              }, option.value);
            } else if ('header' in option) {
              return /*#__PURE__*/jsx("optgroup", {
                label: option.header,
                children: option.options.map(option => /*#__PURE__*/jsx("option", {
                  value: option.value,
                  children: option.label
                }, option.value))
              }, option.header);
            }
            return null;
          })]
        }), /*#__PURE__*/jsx(Arrow, {
          "aria-hidden": "true",
          color: isDisabled ? theme.color.interaction.disabled : theme.color.interaction.contrast
        })]
      }), helpText && /*#__PURE__*/jsx(HelpText, {
        id: helpTextId,
        text: helpText
      }), hasError && errorText && /*#__PURE__*/jsx(ErrorText, {
        id: errorTextId,
        text: errorText
      })]
    })]
  }));
}
var SelectField = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(SelectFieldComponent)));



;// CONCATENATED MODULE: ../node_modules/@lendi/ui/dist/ui.esm.js







































/***/ })

}]);